import { render } from "./Comments.vue?vue&type=template&id=531e2f5f&scoped=true"
import script from "./Comments.vue?vue&type=script&lang=js"
export * from "./Comments.vue?vue&type=script&lang=js"

import "./Comments.vue?vue&type=style&index=0&id=531e2f5f&scoped=true&lang=css"
import "./Comments.vue?vue&type=style&index=1&id=531e2f5f&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531e2f5f"]])

export default __exports__